export default __webpack_public_path__ + "static/media/DK-Sugary-Pancake.756d09cf.otf";